var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHomeIconFitOuts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.1763 30.5706V33.4176",
    stroke: "white",
    strokeWidth: 1.45,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.80615 30.5706V33.4176",
    stroke: "white",
    strokeWidth: 1.45,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.94099 30.4588H37.0586C37.5267 30.4588 37.9755 30.2729 38.3065 29.942C38.6374 29.611 38.8233 29.1622 38.8233 28.6941V16.3412C38.8233 16.0292 38.6994 15.7299 38.4788 15.5093C38.2581 15.2887 37.9589 15.1647 37.6469 15.1647H34.7057C34.3937 15.1647 34.0944 15.2887 33.8738 15.5093C33.6532 15.7299 33.5292 16.0292 33.5292 16.3412V24.6059C33.5292 24.7619 33.4672 24.9115 33.3569 25.0218C33.2466 25.1321 33.097 25.1941 32.941 25.1941H7.05863C6.90262 25.1941 6.753 25.1321 6.64269 25.0218C6.53237 24.9115 6.4704 24.7619 6.4704 24.6059V16.3353C6.4704 16.0233 6.34645 15.724 6.12582 15.5034C5.90519 15.2828 5.60595 15.1588 5.29393 15.1588H2.35275C2.04073 15.1588 1.74149 15.2828 1.52086 15.5034C1.30023 15.724 1.17628 16.0233 1.17628 16.3353V28.6882C1.17551 28.9205 1.22058 29.1506 1.30892 29.3654C1.39726 29.5802 1.52712 29.7754 1.69107 29.9399C1.85501 30.1044 2.04981 30.2349 2.2643 30.3239C2.47879 30.413 2.70875 30.4588 2.94099 30.4588Z",
    stroke: "white",
    strokeWidth: 1.45,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0002 25.1941H7.05905C6.90304 25.1941 6.75342 25.1321 6.6431 25.0218C6.53279 24.9115 6.47081 24.7619 6.47081 24.6059V16.3353C6.47081 16.0233 6.34686 15.724 6.12623 15.5034C5.9056 15.2828 5.60636 15.1588 5.29434 15.1588H3.81787V10.1118C3.81787 9.17571 4.18972 8.27799 4.85161 7.61609C5.5135 6.9542 6.41122 6.58235 7.34728 6.58235H32.6414C33.5775 6.58235 34.4752 6.9542 35.1371 7.61609C35.799 8.27799 36.1708 9.17571 36.1708 10.1118V15.1588H34.7061C34.3941 15.1588 34.0948 15.2828 33.8742 15.5034C33.6536 15.724 33.5296 16.0233 33.5296 16.3353V24.6059C33.5296 24.7619 33.4677 24.9115 33.3573 25.0218C33.247 25.1321 33.0974 25.1941 32.9414 25.1941H20.0002Z",
    stroke: "white",
    strokeWidth: 1.45,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.44141 20.3059H33.5591V24.6059C33.5591 24.7619 33.4971 24.9115 33.3868 25.0218C33.2764 25.1321 33.1268 25.1941 32.9708 25.1941H7.02964C6.87363 25.1941 6.72401 25.1321 6.6137 25.0218C6.50338 24.9115 6.44141 24.7619 6.44141 24.6059V20.3059Z",
    stroke: "white",
    strokeWidth: 1.45,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeIconFitOuts);
export default __webpack_public_path__ + "static/media/Home-Icon-FIT-OUTS.86023532b080ee65db09801093a87b80.svg";
export { ForwardRef as ReactComponent };